import { REQUEST_URL } from "../constants";
import { RequestUtil, RequestFileUtil } from "../utils";
import { SolutionInputModel } from "../models"

export const SolutionService = {
  getAllSolutionPageByLanguage,
  getSolutionPage,
  createSolutionPage,
  uploadImageSolutionPage,
  deleteSolutionPage,
  updateSolutionPage
};

async function getAllSolutionPageByLanguage(query: { languageId: string }) {
  const url = REQUEST_URL.GET_ALL_SOLUTION_PAGE_BY_LANGUAGE;

  return RequestUtil.get({ url, query });
}

async function getSolutionPage(code: string, query?: { languageId?: string }) {
  const url = REQUEST_URL.GET_SOLUTION_PAGE.replace("{CODE}", code);;

  return RequestUtil.get({ url, query });
}

async function createSolutionPage(data: SolutionInputModel[]) {
  const url = REQUEST_URL.CREATE_SOLUTION_PAGE;

  return RequestUtil.post({ url, data });
}

async function uploadImageSolutionPage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_SOLUTION;

  return RequestFileUtil.post({ url, data: formData });
}

async function updateSolutionPage(code: string, data: SolutionInputModel[]) {
  const url = REQUEST_URL.UPDATE_SOLUTION_PAGE.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

async function deleteSolutionPage(code: string) {
  const url = REQUEST_URL.DELETE_SOLUTION_PAGE.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}